// Featured projects shown on the home page. Slugs reference the real
// portfolio catalog (src/pages/Portfolio/portfolioCatalog.ts); the first
// item is rendered as the large "featured" card.
export const featuredSlugs = ['ember', 'lot-12', 'ayb', 'davtashen-residence', 'luyser']
